/** Served from repo `docs/sme-new-lesson-guide.md` (copied at build — see angular.json). */
export const SME_LESSON_GUIDE_ASSET = 'docs/sme-new-lesson-guide.md';
